import React from 'react'
import { HeaderStyle } from './style'

type HeaderProps = React.FC<{
  text: string
}>

export const Header: HeaderProps = ({ text }) => {
  return (
    <HeaderStyle>
      <div>
        <img src="/images/logos/logo-spa-white.png" alt="Logo Spa" />
        <h1>{text}</h1>
      </div>
    </HeaderStyle>
  )
}
